import React, { useState } from 'react'
import { validateEmail } from 'Utils/validation'

interface UseEmailFormProps {
  errorText: string
  initialValue?: string
  submitEmail?: (email: string) => void
}

export const useEmailForm = ({ initialValue, errorText, submitEmail }: UseEmailFormProps) => {
  const [email, setEmail] = useState<string>(initialValue ?? '')
  const [emailError, setEmailError] = useState<string>('')

  const onSubmitEmail = () => {
    if (email.length > 2 && validateEmail(email)) {
      setEmailError('')
      submitEmail && submitEmail(email)
    } else {
      setEmailError(errorText)
    }
  }

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value)
  }

  return {
    email,
    emailError,
    onSubmitEmail,
    handleEmailChange,
    setEmailError,
  }
}
